import React from "react";
import { View, StyleSheet } from "react-native";
import NtText from "../../components/NtText";
import NtMaterialIcon from "../../components/NtMaterialIcon";
import colors from "../../config/colors";

function NtRootPageContainerPermissionAlert({}) {
  return (
    <View style={styles.container}>
      <View style={styles.iconContainer}>
        <NtMaterialIcon
          name="lock-outline"
          color={colors.almostBlack}
          size={50}
        />
      </View>

      <NtText style={styles.title}>Access Restricted</NtText>

      <NtText style={styles.message}>
        You don't have permission to view this page.
      </NtText>

      <NtText style={styles.submessage}>
        Please contact your administrator if you believe this is an error.
      </NtText>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 40,
    paddingVertical: 60,
  },
  iconContainer: {
    width: 100,
    height: 100,
    borderRadius: 50,
    backgroundColor: colors.lighestGray,
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 24,
  },
  title: {
    fontSize: 22,
    fontWeight: "700",
    color: colors.almostBlack,
    marginBottom: 12,
  },
  message: {
    fontSize: 16,
    fontWeight: "500",
    color: colors.almostBlack,
    textAlign: "center",
    marginBottom: 8,
  },
  submessage: {
    fontSize: 14,
    color: colors.lighGray,
    textAlign: "center",
  },
});

export default NtRootPageContainerPermissionAlert;
